import Endpoints from '@commons/communication/endpoints.js'

export default{
    mixins: [Endpoints],
    props:['categoryId'],
    data:function () {
        return {
            products:[]
        };
    },
    created:function () {
        var self =this;

        var catId = this.categoryId == undefined?null:this.categoryId

        this.connGetPromotedProducts(catId,function (r) {
            self.products = r.data.list
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/main/components/pages/list/Promoted.js